import { useMemo } from 'react';
import { makeApproveeByIdFromMap, makeResourceByIdFromMap } from '../../../selectors/resource';
import { useSelector } from 'react-redux';

export const useResourceToilPolicyId = resourceId => {
    const approveeSelector = useMemo(() => makeApproveeByIdFromMap(resourceId), [resourceId]);
    const approvee = useSelector(approveeSelector);

    const resourceSelector = useMemo(() => makeResourceByIdFromMap(resourceId), [resourceId]);
    const resource = useSelector(resourceSelector);

    return resource?.toilPolicyId || approvee?.toilPolicyId;
};
